import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import ArrowForwardIosRounded from '../../../../assets/ArrowForwardIosRounded.svg';

export const Div = styled(Box)`
  .recover-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 63%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ten-meetings {
    width: 180px;
    min-width: 180px;

    position: fixed;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    position: relative;
    top: 0.5rem;
    margin-top: 0.18rem;
    margin-bottom: 1.2rem;
    color: ${({ theme }) => theme.palette.grey[100]};
  }

  .title-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000;
  }

  .container-input {
    width: 22rem;
  }

  .inputNumber {
    width: 2rem;
    height: 3rem;
    display: flex;
    position: relative;
    text-align: center;
    bottom: 0.4rem;
  }

  .container-confirm {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .btn-confirm {
    left: 0;
    right: 0;
    margin-bottom: 1.25rem;
    width: 6.25rem;
    height: 2.62rem;
  }

  .alert-validation {
    width: 411.8px;
    display: flex;
    justify-content: center;
    margin-top: 1.56rem;
  }
  .contentHeader {
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: column;
    gap: 1.87rem;
  }

  .dialog-span {
    text-align: center;
    font-size: 0.93rem;
  }
  .modalTitle {
    font-size: 1.31rem;
    margin-top: 1rem;
  }

  .modal-email {
    margin-top: 3.2rem;
    width: 31.25rem;
  }

  .modal-confirm {
    margin-bottom: 4rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .icon-success {
    margin-top: 3.87rem;
  }

  .message-success {
    margin-top: 2rem;
  }

  h3 {
    font-size: 2.32rem;
  }
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 100%;
  height: 70px !important;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;
  cursor: pointer;
  justify-content: space-between;

  :hover {
    filter: brightness(0.97);
    ::after {
      content: url(${ArrowForwardIosRounded});
    }
  }
`;

export const CardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2px;
`;

export const CardTitle = styled(Box)`
  color: var(--black, #000);
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.15px;
`;

export const Title = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4caf50;
`;
